import { LoadAlertStatus } from './AppConstants'
import { canBeAssignedSupplierInLoadAlert, canBeModuleLoadAlert } from './RolesHelper'
import { IsUserSupplierAdministrator } from './SessionHelper'

export function canBeEditSupplierInformation(loadAlert, userRolesByCompany, userProfile, loadAlertItem) {
	console.log('userProfile', userProfile)
	if (userRolesByCompany === undefined) return false
	if (userProfile === null || userProfile === undefined) return false
	if (loadAlert === null || loadAlert === undefined) return false
	if (loadAlert.status !== LoadAlertStatus.DRAFT) return false
	if (!loadAlertItem) return false
	if (userProfile.profile.company_code !== loadAlertItem.supplierCode) return false
	let supplierAdmin = IsUserSupplierAdministrator(userProfile)
	return supplierAdmin || canBeModuleLoadAlert(userRolesByCompany)
}

export function canBeEditInternalUserInformation(loadAlert, userRolesByCompany, userProfile, isInternalUser) {
	if (userRolesByCompany === undefined) return false
	if (userProfile === null || userProfile === undefined) return false
	if (loadAlert === null || loadAlert === undefined) return false
	if (!isInternalUser) return false

	let supplierAdmin = IsUserSupplierAdministrator(userProfile)
	return supplierAdmin || canBeAssignedSupplierInLoadAlert(userRolesByCompany)
}
